<template>
    <facility-and-project-main-container>
        <template #title>
            Contract Admin
        </template>
        <template #controls>
            <create-new-button
                button-text="Create new contract"
                library-name="Contract"
                @onClick="newContract" />
        </template>
        <template #new>
            <router-view
                :code-set-name="codeSetName"
                title="Create a new contract"
                library="Contract"
                @onRefresh="onRefresh"
                @onCancel="onCancel" />
        </template>
        <template #contracts>
            <b-table
                :loading="loading"
                :data="contractList.data"
                default-sort="Name"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                class="site-sticky-header">
                <b-table-column
                    v-slot="props"
                    field="Name"
                    label="Name"
                    sortable>
                    <router-link
                        :to="getContractLink(props.row)">
                        {{ props.row.Name }}
                    </router-link>
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="IsValid"
                    label="Is valid"
                    centered
                    sortable>
                    <bool-element :value="props.row.IsValid" />
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="Description"
                    label="Description"
                    sortable>
                    {{ props.row.Description }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="ProjectName"
                    label="Project"
                    sortable>
                    <router-link
                        v-if="props.row.ProjectName"
                        :to="getProjectLink(props.row)">
                        {{ props.row.ProjectName }}
                    </router-link>
                </b-table-column>
            </b-table>
        </template>
    </facility-and-project-main-container>
</template>

<script>
    import BoolElement from '@/shared/components/BoolElement.vue';
    import { genericViewQueryAsText, getCodeSets } from '@/shared/helpers/api';
    import { requireCanEditCode } from '@/shared/directives/requirePermission';
    import { encodeIdBase64 } from '@/shared/helpers/utils';
    import ViewBaseFacilityAndProject from '@/apps/facilityAndProject/ViewBaseFacilityAndProject.vue';
    import CreateNewButton from '@/apps/facilityAndProject/CreateNewButton.vue';

    export default {
        directives: {
            'require-can-edit-code': requireCanEditCode
        },
        components: {
            CreateNewButton,
            FacilityAndProjectMainContainer: ViewBaseFacilityAndProject,
            BoolElement
        },
        data() {
            return {
                contractList: {},
                loading: true,
                codeSetName: null,
                contractListGQ: `
                    FROM Contract
                    SELECT Id, Name, Identity, Description, IsValid
                    WHERE IsValid = true
                    JOIN ProjectMaster SELECT Id AS ProjectId, Name AS ProjectName`
            };
        },
        async mounted() {
            this.codeSetName = (await getCodeSets(this, 'Contract'))[0].name;
            this.contractList = await genericViewQueryAsText(this, this.contractListGQ);
            this.loading = false;
        },
        methods: {
            getProjectLink(f) {
                return { name: 'FacilityAndProjectById', params: { id: encodeIdBase64('Code', f.ProjectId) } };
            },
            getContractLink(f) {
                return { name: 'ContractById', params: { id: encodeIdBase64('Code', f.Id) } };
            },
            newContract() {
                this.$router.push({ name: 'CreateNewContract' });
            },
            async onRefresh() {
                await this.$router.push({ name: 'ContractList' });
                this.contractList = await genericViewQueryAsText(this, this.contractListGQ);
            },
            onCancel() {
                this.$router.push({ name: 'ContractList' });
            }
        }
    };
</script>
